import React, { useState, useEffect, useContext } from 'react';
import { FaCogs } from 'react-icons/fa';
import Carousel from 'react-bootstrap/Carousel';
import { useNavigate } from 'react-router-dom';
import { LanguageContext } from './LanguageContext';
import { useSwipeable } from 'react-swipeable';
import './Home.css';

function Home() {
  const [activeIndex, setActiveIndex] = useState(0);
  const navigate = useNavigate();
  const { language } = useContext(LanguageContext);

  const handleExploreMaestroClick = () => {
    navigate('/products/maestro');
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }, 100); // Adjust the delay as needed
  };

  const handleSelect = (selectedIndex) => {
    setActiveIndex(selectedIndex);
  };

  // Add swipe handlers
  const handlers = useSwipeable({
    onSwipedLeft: () => setActiveIndex((prevIndex) => (prevIndex + 1) % 5), // Assuming 5 items
    onSwipedRight: () => setActiveIndex((prevIndex) => (prevIndex - 1 + 5) % 5), // Assuming 5 items
    preventDefaultTouchmoveEvent: true,
    trackMouse: true // Optional: allows swipe with mouse
  });

  useEffect(() => {
    const resetMarginTop = () => {
      const carouselSection = document.querySelector('.carousel-section');
      if (carouselSection) {
        carouselSection.style.marginTop = '0'; // Reset to 0
      }
    };
  
    resetMarginTop();
    window.addEventListener('resize', resetMarginTop);
  
    return () => {
      window.removeEventListener('resize', resetMarginTop);
    };
  }, []);
  

  useEffect(() => {
    const indicators = document.querySelectorAll('.custom-indicators .progress-bar');
    indicators.forEach((bar, index) => {
      if (index === activeIndex) {
        bar.style.animation = 'none'; // Stop the animation
        void bar.offsetWidth; // Trigger a reflow
        bar.style.animation = `progress 4s linear forwards`; // Restart the animation
      } else {
        bar.style.animation = 'none'; // Ensure inactive indicators do not animate
      }
      });
    }, [activeIndex]);

  const scrollToSection = (index) => {
    const section = document.querySelector(`#section-${index}`);
    if (section) {
      const headerOffset = 70; // Adjust this value based on your fixed header height
      const elementPosition = section.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  useEffect(() => {
    // Scroll to the top of the page when the component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container-fluid p-0" {...handlers}>
      <section className="carousel-section position-relative">
        {/* Carousel */}
        <Carousel
          interval={4000}
          pause={false}
          indicators={false}
          activeIndex={activeIndex}
          onSelect={handleSelect}
        >
          <Carousel.Item onClick={() => scrollToSection(activeIndex)}>
            <img
              className="d-block w-100 carousel-img carousel-img-maestro"
              src="/images/maestro4.jpg"
              alt="Maestro by Tacosoft"
            />
            <Carousel.Caption>
              <h1>{language === 'en' ? 'Maestro by Tacosoft' : 'Tacosoft\'tan Maestro'}</h1>
              <p>{language === 'en' ? 'Take a look at our most popular software Maestro' : 'En popüler yazılımımız Maestro\'ya bir göz atın'}</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item onClick={() => scrollToSection(activeIndex)}>
            <img
              className="d-block w-100 carousel-img"
              src="/images/formula1.jpg"
              alt="Leading Company"
            />
            <Carousel.Caption>
              <h1>{language === 'en' ? 'Leading Company' : 'Önde Gelen Şirket'}</h1>
              <p>{language === 'en' ? 'More than 20 years of experience' : '20 yılı aşkın deneyim'}</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item onClick={() => scrollToSection(activeIndex)}>
            <img
              className="d-block w-100 carousel-img carousel-img-maestro"
              src="/images/khasTeknoparkPic.jpg"
              alt="Tacosoft at Kadir Has Technopark"
            />
            <Carousel.Caption>
              <h1>
                <a
                  href="https://khasteknopark.com.tr/tacosoft/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-link"
                >
                  {language === 'en' ? 'Tacosoft is at Kadir Has Technopark!' : 'Tacosoft, Kadir Has Teknopark\'ta!'}
                </a>
              </h1>
              <p>{language === 'en' ? 'At Kadir Has Technopark, we are taking our project Maestro to the next level!' : 'Kadir Has Teknopark\'ta, Maestro projemizi bir sonraki seviyeye taşıyoruz!'}</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item onClick={() => scrollToSection(activeIndex)}>
            <img
              className="d-block w-100 carousel-img"
              src="/images/meeting1.jpg"
              alt="High Customer Satisfaction"
            />
            <Carousel.Caption>
              <h3>{language === 'en' ? 'High Customer Satisfaction' : 'Yüksek Müşteri Memnuniyeti'}</h3>
              <p>{language === 'en' ? 'User-friendly, living software with software rental and support services' : 'Kullanıcı dostu, yazılım kiralama ve destek hizmetleri ile yaşayan yazılım'}</p>
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item onClick={() => scrollToSection(activeIndex)}>
            <img
              className="d-block w-100 carousel-img"
              src="/images/secure.jpg"
              alt="Secure Data and Robust Database"
            />
            <Carousel.Caption>
              <h3>
                <a
                  href="https://www.equinix.com/data-centers/europe-colocation/turkey-colocation/istanbul-data-centers"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-link"
                >
                  {language === 'en' ? 'Secure Data and Robust Database' : 'Güvenli Veri ve Sağlam Veritabanı'}
                </a>
              </h3>
              <p>
                <a
                  href="https://www.equinix.com/data-centers/europe-colocation/turkey-colocation/istanbul-data-centers"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-link"
                >
                  {language === 'en' ? 'We keep your data in one of Europe\'s most secure database centers, Equinix' : 'Verilerinizi Avrupa\'nın en güvenli veri merkezlerinden biri olan Equinix\'te saklıyoruz'}
                </a>
              </p>
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>

       
        {/* Custom Indicators */}
        <div className="custom-indicators">
          {[...Array(5).keys()].map((index) => (
            <div
              key={index}
              className={`indicator ${index === activeIndex ? 'active' : ''}`}
              onClick={() => setActiveIndex(index)}
            >
              <div className="progress-bar"></div>
            </div>
          ))}
        </div>
      </section>

      {/* Detailed Sections for Each Carousel Item */}
      <section id="section-0" className="details-section my-5">
        <div className="container">
          <h2 className="text-center mb-4">
            <FaCogs /> {language === 'en' ? 'Maestro CMMS by Tacosoft' : 'Tacosoft\'tan Maestro CMMS'}
          </h2>
          
          <div className="row justify-content-center my-4 position-relative">
            <div className="col-md-4 text-center key-features-box">
              <h4>{language === 'en' ? 'Key Features' : 'Ana Özellikler'}</h4>
              <ul className="list-unstyled">
                <li>{language === 'en' ? 'Real-time analytics' : 'Gerçek zamanlı analiz'}</li>
                <li>{language === 'en' ? 'Customizable dashboards' : 'Özelleştirilebilir panolar'}</li>
                <li>{language === 'en' ? 'Seamless integration with existing systems' : 'Mevcut sistemlerle sorunsuz entegrasyon'}</li>
                <li>{language === 'en' ? '24/7 customer support' : '7/24 müşteri desteği'}</li>
              </ul>
            </div>
            <div className="col-md-4 text-center key-features-box">
              <h4>{language === 'en' ? 'Benefits' : 'Faydalar'}</h4>
              <ul className="list-unstyled">
                <li>{language === 'en' ? 'Increased productivity' : 'Artan verimlilik'}</li>
                <li>{language === 'en' ? 'Enhanced decision-making' : 'Gelişmiş karar verme'}</li>
                <li>{language === 'en' ? 'Cost-effective solutions' : 'Maliyet etkin çözümler'}</li>
                <li>{language === 'en' ? 'Scalable for businesses of all sizes' : 'Her büyüklükteki işletme için ölçeklenebilir'}</li>
              </ul>
            </div>
            <div className="arrow-to-advanced text-center">↓</div>
          </div>
          <div className="row justify-content-center my-4">
            <div className="col-md-6 text-center advanced-features">
              <h4>{language === 'en' ? 'Advanced Features' : 'Gelişmiş Özellikler'}</h4>
              <ul className="list-unstyled advanced-features-list">
                <li>{language === 'en' ? 'Smart Maps: Visualize and manage work requests directly on a map.' : 'Akıllı Haritalar: İş taleplerini doğrudan bir harita üzerinde görselleştirin ve yönetin.'}</li>
                <li>{language === 'en' ? 'Equipment Barcoding: Seamless tracking with unique identifiers.' : 'Ekipman Barkodlama: Benzersiz tanımlayıcılarla sorunsuz izleme.'}</li>
                <li>{language === 'en' ? 'Checklists: Efficiently manage routine inspections.' : 'Kontrol Listeleri: Rutin denetimleri verimli bir şekilde yönetin.'}</li>
                <li>{language === 'en' ? 'Calibration: Ensure accuracy and regulatory compliance.' : 'Kalibrasyon: Doğruluğu ve yasal uyumu sağlayın.'}</li>
                <li>{language === 'en' ? 'Stock Tracking: Real-time inventory management.' : 'Stok Takibi: Gerçek zamanlı envanter yönetimi.'}</li>
                <li>{language === 'en' ? 'Mobile Optimized Interface: Access Maestro on the go.' : 'Mobil Optimizasyonlu Arayüz: Maestro\'ya hareket halindeyken erişin.'}</li>
              </ul>
            </div>
          </div>
          <div className="text-center">
            <button className="btn btn-primary mx-2" onClick={handleExploreMaestroClick}>
              {language === 'en' ? 'Explore Maestro' : 'Maestro\'yu Keşfedin'}
            </button>
          </div>
        </div>
      </section>

      <section id="section-2" className="details-section my-5">
        <h2 className="text-center mb-4">{language === 'en' ? 'Tacosoft at Kadir Has Technopark for Maestro' : 'Tacosoft, Maestro için Kadir Has Teknopark\'ta'}</h2>
        <div className="row justify-content-center my-4">
          <div className="col-md-6 d-flex align-items-center justify-content-center key-features-box">
            <img src="/images/khasteknopark.png" alt="Company Image" className="img-fluid mr-3" style={{ maxWidth: '350px', borderRadius: '8px' }} />
            <ul className="list-unstyled mb-0">
              <li>{language === 'en' ? 'Chatbot' : 'Sohbet Botu'}</li>
              <li>{language === 'en' ? 'Different languages support for Maestro' : 'Maestro için farklı dil desteği'}</li>
              <li>{language === 'en' ? 'IoT integration' : 'IoT entegrasyonu'}</li>
              <li>{language === 'en' ? 'AI integration' : 'Yapay Zeka entegrasyonu'}</li>
            </ul>
          </div>
        </div>
      </section>


      <section id="section-1" className="details-section my-5">
        <h2 className="text-center mb-4">{language === 'en' ? 'Leading Company' : 'Önde Gelen Şirket'}</h2>
        <div className="row justify-content-center my-4">
          <div className="col-md-6 d-flex align-items-center justify-content-center key-features-box">
            <img src="/images/companypic.jpg" alt="Company Image" className="img-fluid mr-3" style={{ maxWidth: '350px', borderRadius: '8px' }} />
            <ul className="list-unstyled mb-0">
              <li>{language === 'en' ? 'More than 20 years of experience.' : '20 yılı aşkın deneyim.'}</li>
              <li>{language === 'en' ? 'High Customer Satisfaction' : 'Yüksek Müşteri Memnuniyeti'}</li>
              <li>{language === 'en' ? 'User-friendly, living softwares with software rental and support services.' : 'Kullanıcı dostu, yazılım kiralama ve destek hizmetleri ile yaşayan yazılımlar.'}</li>
            </ul>
          </div>
        </div>
      </section>

      <section id="section-4" className="details-section my-5">
        <h2 className="text-center mb-4">{language === 'en' ? 'Secure Data and Robust Database' : 'Güvenli Veri ve Sağlam Veritabanı'}</h2>
        <div className="row justify-content-center my-4">
          <div className="col-md-6 d-flex align-items-center justify-content-center key-features-box">
            <img src="/images/database1.jpeg" alt="Company Image" className="img-fluid mr-3" style={{ maxWidth: '350px', borderRadius: '8px' }} />
            <ul className="list-unstyled mb-0">
              <li>{language === 'en' ? 'Database and server runs in Equinix data center' : 'Veritabanı ve sunucu Equinix veri merkezinde çalışır'}</li>
              <li>{language === 'en' ? 'Almost 100% uptime' : 'Neredeyse %100 çalışma süresi'}</li>
              <li>{language === 'en' ? 'High security' : 'Yüksek güvenlik'}</li>
              <li>{language === 'en' ? 'High performance' : 'Yüksek performans'}</li>
            </ul>
          </div>
        </div>
      </section>

    </div>
  );
}

export default Home;
